module.exports = __webpack_public_path__ + "img/15.9e17b96b.jpeg";